import { UseCasePage } from "../components/UseCasePage";
import { recruitingScreeningCallCopy } from "../lib/translations/pages/use-case-recruiting-screening-call";

export function RecruitingScreeningCall() {
  return (
    <UseCasePage
      content={recruitingScreeningCallCopy}
      path="/use-cases/recruiting-screening-call"
    />
  );
}
